import { API_BASE_URL } from "./api";

// Auth-failure diagnostic. Every time a silent-token / login failure occurs (the
// failure that can force a second interactive sign-in), we report a MINIMAL,
// non-sensitive record to the backend so any recurrence is visible in our logs
// without ever asking a user to open a console. No token, no password, no error
// message body leaves the browser — only { where, errorCode, email, at }.
//
// A fuller local copy is kept in localStorage('__authDiag') ONLY on dev, for our
// own testing — production browsers get no diagnostic key.
//   Inspect on dev with:  JSON.parse(localStorage.getItem('__authDiag'))

const isDevHost =
  typeof window !== "undefined" &&
  (window.location.hostname.startsWith("dev") || window.location.hostname === "localhost");

function currentEmail() {
  try {
    return JSON.parse(localStorage.getItem("userData") || "null")?.email;
  } catch {
    return undefined;
  }
}

export function recordAuthDiag(where, error, extra = {}) {
  const at = new Date().toISOString();
  const errorCode = (error && error.errorCode) || (extra && extra.errorCode) || undefined;

  // 1) Server beacon — fire ONLY for events explicitly flagged { beacon: true },
  //    i.e. an actual forced second sign-in / bounce. Everything else stays a
  //    dev-only local diagnostic (below), so PROD telemetry is high-signal: a
  //    beacon means a real double sign-in to investigate, never routine
  //    cold-start silent-renewal noise. On a healthy prod this stays silent.
  //    Minimal, non-sensitive, fire-and-forget; text/plain avoids a CORS preflight
  //    (beacons don't reliably complete a preflight mid-navigation).
  if (extra && extra.beacon === true) {
    try {
      const payload = JSON.stringify({ at, where, errorCode, email: currentEmail() });
      const url = `${API_BASE_URL}/api/telemetry/auth-diag`;
      if (typeof navigator !== "undefined" && navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([payload], { type: "text/plain" }));
      }
    } catch {
      // Telemetry must never affect the auth flow.
    }
  }

  // 2) Local buffer — DEV ONLY. Not written on production hosts.
  if (isDevHost) {
    try {
      const diag = JSON.parse(localStorage.getItem("__authDiag") || "[]");
      diag.push({
        at,
        where,
        name: error && error.name,
        errorCode,
        subError: error && error.subError,
        msg: error && error.message ? String(error.message).slice(0, 250) : undefined,
        ...extra,
      });
      localStorage.setItem("__authDiag", JSON.stringify(diag.slice(-25)));
    } catch {
      /* no-op */
    }
  }
}
